import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle } from "lucide-react";
import { COMPANY, LOGO_URL } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-[#0A192F] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        {/* Closing CTA */}
        <div className="mb-14 grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <h3 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">
              Have more questions?{" "}
              <span className="text-[#00B4D8]">Contact us today.</span>
            </h3>
            <p className="mt-4 text-white/70 text-base lg:text-lg max-w-xl">
              We're here to help. Free estimates, fast response, and friendly
              service across Tampa Bay.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                data-testid="footer-call-btn"
                href={COMPANY.smsLink}
                className="inline-flex items-center justify-center gap-2 bg-[#00B4D8] hover:bg-[#0096C7] text-white px-7 py-3.5 rounded-full font-semibold transition-all hover:-translate-y-0.5"
              >
                <Phone className="w-4 h-4" />
                Get A Free Estimate
              </a>
              <a
                data-testid="footer-email-btn"
                href={`mailto:${COMPANY.email}?subject=Solar%20Service%20Inquiry`}
                className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 border border-white/20 text-white px-7 py-3.5 rounded-full font-semibold transition-all"
              >
                <Mail className="w-4 h-4" />
                Contact Us
              </a>
            </div>
          </div>

          <div className="lg:justify-self-end w-full lg:max-w-sm">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
              <p className="text-xs font-bold tracking-[0.18em] uppercase text-[#00B4D8]">
                Get in touch
              </p>
              <ul className="mt-4 space-y-3 text-sm text-white/85">
                <li className="flex items-start gap-3">
                  <Phone className="w-4 h-4 text-[#00B4D8] mt-1 shrink-0" />
                  <a
                    href={`tel:${COMPANY.phoneTel}`}
                    className="hover:text-white"
                  >
                    {COMPANY.phone}
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Mail className="w-4 h-4 text-[#00B4D8] mt-1 shrink-0" />
                  <a
                    href={`mailto:${COMPANY.email}`}
                    className="hover:text-white break-all"
                  >
                    {COMPANY.email}
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-[#00B4D8] mt-1 shrink-0" />
                  <span>
                    {COMPANY.serviceArea} · ZIP {COMPANY.zip}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-xl p-1.5">
              <img
                src={LOGO_URL}
                alt={COMPANY.name}
                className="h-10 w-auto"
              />
            </div>
            <div>
              <p className="font-heading font-bold tracking-tight">
                {COMPANY.name}
              </p>
              <p className="text-xs text-white/60">
                Solar Cleaning · Installation · Maintenance
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              data-testid="footer-social-fb"
              href={COMPANY.social.facebook}
              aria-label="Facebook"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#00B4D8] border border-white/10 flex items-center justify-center transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              data-testid="footer-social-ig"
              href={COMPANY.social.instagram}
              aria-label="Instagram"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#00B4D8] border border-white/10 flex items-center justify-center transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              data-testid="footer-social-wa"
              href={COMPANY.social.whatsapp}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#00B4D8] border border-white/10 flex items-center justify-center transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-white/50">
          <p>
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p>Licensed & insured · Tampa Bay, Florida</p>
        </div>
      </div>
    </footer>
  );
}
